export default "__VITE_PUBLIC_ASSET__1f536b9b__"